// extracted by mini-css-extract-plugin
export default {"sixth-screen":"SixthScreen_sixth-screen__3bCNJ","background":"SixthScreen_background__GfFLM","content":"SixthScreen_content__2ybNR"};